import { BarChart, Bar, Cell, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { motion } from "framer-motion";
import { WhatDoesThisMean } from "../shared/WhatDoesThisMean";

export function StoreRevenueCard({ totalRevenue, monthlyBreakdown, currentMonthRevenue, currentMonthLabel }) {
  const currentMonthAlreadyIncluded = monthlyBreakdown.some((m) => m.month === currentMonthLabel);
  const chartData = [...monthlyBreakdown];
  if (currentMonthRevenue && !currentMonthAlreadyIncluded) {
    chartData.push({ month: currentMonthLabel || "Now", revenue: currentMonthRevenue, inProgress: true });
  }

  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5, delay: 0.05 }} className="bg-igc-surface border border-igc-gold/15 p-6 h-full" data-testid="store-revenue-card">
      <p className="text-igc-muted text-xs uppercase tracking-widest mb-2">
        Store Revenue
        <WhatDoesThisMean
          testId="store-revenue-explainer"
          text="This is your store's total lifetime revenue based on all approved sales reports since it went live."
        />
      </p>
      <p className="font-serif text-3xl text-igc-cream mb-1" data-testid="total-revenue-value" title="Your store's total lifetime revenue, added up from every approved sales report since launch.">${totalRevenue.toLocaleString()}</p>
      <p className="text-igc-muted text-xs mb-4">All-time revenue</p>
      <div className="h-40">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={chartData}>
            <XAxis dataKey="month" tick={{ fill: "#7a7468", fontSize: 11 }} axisLine={{ stroke: "rgba(201,165,53,0.25)" }} tickLine={false} />
            <YAxis hide />
            <Tooltip contentStyle={{ backgroundColor: "#ffffff", border: "1px solid rgba(201,165,53,0.3)", borderRadius: 0 }} labelStyle={{ color: "#1a1a1a" }} itemStyle={{ color: "#c9a535" }} />
            <Bar dataKey="revenue" radius={[2, 2, 0, 0]}>
              {chartData.map((entry, index) => (
                <Cell key={index} fill={entry.inProgress ? "rgba(201,165,53,0.4)" : "#c9a535"} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
      {currentMonthRevenue > 0 && (
        <p className="text-igc-muted text-xs mt-2" data-testid="current-month-revenue">
          {currentMonthLabel} (in progress): <span className="text-igc-goldText">${currentMonthRevenue.toLocaleString()}</span>
        </p>
      )}
    </motion.div>
  );
}
